import React, { forwardRef, useEffect, useState } from "react";
import Checkbox from "../../../generic/checkbox";
import InputField from "../../../generic/inputField";
import RadioButton from "../../../generic/radioButton";
import {
  getBankListForIfsc,
  checkPennyDrop,
} from "../../../service/generic/otherApi";
import {
  CreateServiceRequestDetails,
  GetEquityReactivationClientValidation,
  CreateChildServiceRequestDetails,
  GetAllNewExistingSRDetails,
  createSRDocumentUpload,
  getDefaultBankValidationDetails,
  GetDepositoryDetails,
} from "../../../service/serviceRequest/srApiService";
import { alphaNumExp, integerExp } from "../../../utils/regex";
import { BankUpload } from "./upload";
import { config } from "../../../../config/domain";
import { BankIfscpop } from "./BankIfscpop";
import { getAutoQc } from "../../generic/qCCheck";
import { StatusScreen } from "../../generic/statusScreen";
import { asyncGetServiceRequest } from "../../../service/postLogin/clientProfileAPIService";
import TocDropdown from "../../../generic/tocDropdown";
import * as esignService from "../../../service/esign/esignService";
import { useQuery } from "../../../service/urlHelper";
import {getinvAccDet} from "../../../service/login/loginService"
let invOnlyAcc = getinvAccDet();

const accType: Array<any> = [
  { value: "Savings", display: "Savings" },
  { value: "Current", display: "Current" },
];

export const Bank = forwardRef((props: any, ref: any) => {
  const source = useQuery().get("source");

  const [bankForm, setBankForm] = useState<any>({
    accNo: "",
    ifsc: "",
    micr: "",
    accType: accType[0].value,
    city: "",
    branch: "",
    reAcc: "",
    bankName: "",
    primaryAcc: false,
    submitted: false,
    accName: "",
    accCode: "",
  });
  const [tempBank, setTempBank] = useState<any>({
    accNo: "",
    ifsc: "",
  });
  const addressConsent = useQuery().get("consent");
  const consentType = useQuery().get("consentType");
  const [addBank, setAddBank] = useState<any>(false);
  const [ifscPop, setIfscPop] = useState<any>(false);
  const [errorMsg, setErrorMsg] = useState<any>("");
  const [errors, setErrors] = useState<any>({
    accNoError: "",
    reAccError: "",
    ifscError: "",
    duplicBankErr: "",
  });
  const [documentUpload, setDocumentUpload] = useState<any>(false);
  const [existingBankDet, setExistingBankDet] = useState<any>([]);
  const [fileDet, setFileDet] = useState<null | any>({});
  //const [loader, setLoader] = useState(true);
  const [existingBankSR, setExistingBankSR] = useState("");
  const [autoQC, setAutoQC] = useState("NA");
  const [serReqId, setSerReqId] = useState("");
  const [checkAutoQcFlag, setCheckAutoQcFlag] = useState<any>();
  const [micrArr, setmicrArr] = useState<any>([]);
  const [micrList, setMicrList] = useState([]);
  const [pennyResponse, setPennyResponse] = useState("");
  const [primaryBankModified, setPrimaryBankModified] = useState(false);
  const [defaultbankMsg, setDefaultBankMsg] = useState<any>(null);
  const [editExisting, setEditExisting] = useState(false);
  const [editBankNo, setEditBankNo] = useState(-1);
  const [disablePrimaryCheckbox, setDisablePrimaryCheckbox] = useState<boolean>(false);
  const [userConsent, setUserConsent] = useState(false);
  const sr = useQuery().get("srID");
  const srId = props.childSr ? props.getChildSr(3) : sr;
  const [serviceReqListArr, setServiceReqListArr] = useState<any>();
  let storedList = window.sessionStorage.getItem("serviceReqList");
  React.useEffect(() => {
    if (props.setParLoader) props.setParLoader(true);
    if (srId) getEditBankDet();
    else {
      if (!props.childSr) checkExistingBankSR();
      else {
        props.showFooter(false);
        //props.setLoader(false);
        if (props.userData) {
          if (
            props.userData.BankDetails &&
            props.userData.BankDetails.length > 0
          ) {
            if (props.userData.BankDetails.length > 0) {
              let hasFundingBank: boolean = false;
              props.userData.BankDetails.forEach((ele: any) => {
                ele.oldDefBankVal = ele.DefaultBank;
                if (ele.FundingBank === "Yes") hasFundingBank = true;
              });
              if (hasFundingBank) setErrorMsg("fundingBankError");
            }
            setExistingBankDet(props.userData.BankDetails);
          }
          setBankForm({
            ...bankForm,
            accName: props.userData.FullAcName,
            accCode: props.userData.AccountCode,
          });
        } else {
          openSRErrorPopup();
        }
      }
    }
  }, []);

  React.useEffect(() => {
    if (checkAutoQcFlag && autoQC) clearInterval(checkAutoQcFlag);
  }, [autoQC]);

  useEffect(() => {
      setServiceReqListArr(storedList ? JSON.parse(storedList) : []);
  }, [storedList]);
  useEffect(() => {
    if (defaultbankMsg) props.setLoader(false);
  }, [defaultbankMsg]);

  useEffect(() => {
    if (disablePrimaryCheckbox) {
      setBankForm({
        ...bankForm,
        primaryAcc: true,
      });

      onSetExistingBank("DefaultBank", "No");
    }
  }, [disablePrimaryCheckbox]);

  const checkIfHasMatchAndDef = () => {
    var hasMatch = false;
    if (isValidForm())
      existingBankDet.forEach((ele: any) => {
        if (
          ele.BankAccountNumber &&
          ele.BankAccountNumber === bankForm.accNo &&
          ((ele.IFSC_Code && ele.IFSC_Code !== bankForm.ifsc) 
          // || (ele.MICR_Code && ele.MICR_Code !== bankForm.micr)
          )
           &&
          ele.ReEnterBankAccountNumber &&
          ele.ReEnterBankAccountNumber === bankForm.reAcc &&
          (!srId
            ? ele.oldDefBankVal === "Yes"
            : ele.bank_modified && !ele.default_account_flag)
        ) {
          hasMatch = true;
          
          return;
        }
      });
    return hasMatch;
  };

  const existingBankDetModified = () => {
    let dataModified = false;
    existingBankDet.forEach((ele: any) => {
      if (srId) {
        if (ele.oldDefBankVal !== ele.DefaultBank) {
          if (!ele.bank_modified)
            dataModified = true;
        } else {
          if (ele.bank_modified) dataModified = true;
        }
      } else if (ele.oldDefBankVal !== ele.DefaultBank) dataModified = true;
    });
    
    return dataModified;
  };
  const isPrimBnkNotModif = () => {
    let dataModified = existingBankDet.some((bankdetails: any, index: any) => {
      return (
        (bankdetails.default_account_flag && !bankdetails.bank_modified) ||
        (bankdetails.DefaultBank === "Yes" &&
          !bankdetails.default_account_flag &&
          bankdetails.bank_modified)
      );
    });
    return dataModified;
  };
  React.useEffect(() => {
    if (existingBankDet.length > 0 && props.parentLoader) {
      if (props.setParLoader) props.setParLoader(false);
    }
    if (existingBankDetModified() || bankForm.primaryAcc)
      setPrimaryBankModified(true);
    else setPrimaryBankModified(false);
    var hasMatch = false;
    existingBankDet.forEach((ele: any) => {
      if (
        ele.BankAccountNumber &&
        ele.BankAccountNumber === bankForm.accNo &&
        ele.IFSC_Code &&
        ele.IFSC_Code === bankForm.ifsc &&
        ele.MICR_Code &&
        // ele.MICR_Code === bankForm.micr &&
        ele.ReEnterBankAccountNumber &&
        ele.ReEnterBankAccountNumber === bankForm.reAcc
      ) {
        hasMatch = true;
        return;
      }
    });
    if (checkIfHasMatchAndDef()) setDisablePrimaryCheckbox(true);
    else setDisablePrimaryCheckbox(false);
    if (hasMatch)
      setErrors({
        ...errors,
        duplicBankErr: "This bank details already exists.",
        accNoError: isValidForm() ? "" : errors.accNoError,
        reAccError: isValidForm() ? "" : errors.reAccError,
      });
    else
      setErrors({
        ...errors,
        accNoError: isValidForm() ? "" : errors.accNoError,
        reAccError: isValidForm() ? "" : errors.reAccError,
        duplicBankErr: "",
      });
  }, [existingBankDet, bankForm]);

  useEffect(() => {
    if (pennyResponse) setPennyResponse("");
    if (isValidForm()) defaultBankValidation(bankForm.accNo, bankForm.ifsc);
    else if (defaultbankMsg) setDefaultBankMsg("");
  }, [bankForm.accNo, bankForm.ifsc, bankForm.micr, bankForm.reAcc]);
  React.useEffect(() => {
    //reset primary bank checkbox
    if (!isValidForm() && bankForm.primaryAcc) {
      setBankForm({ ...bankForm, primaryAcc: false });
      setPrimaryBankModified(false);
      if (srId)
        existingBankDet.forEach((ele: any) => {
          if (noDefaultBank()) {
            if (
              (ele.bank_modified && !ele.default_account_flag) ||
              (ele.bank_modified && ele.default_account_flag)
            )
              ele.DefaultBank = "Yes";
            else ele.DefaultBank = "No";
          }
        });
      else
        existingBankDet.forEach((ele: any) => {
          ele.DefaultBank = ele.oldDefBankVal;
        });
    }
  }, [errors, bankForm.primaryAcc]);

  const isValidForm = () => {
    return !(
      bankForm.accNo.length < 8 ||
      bankForm.accNo.length > 18 ||
      (bankForm.accNo && bankForm.accNo !== bankForm.reAcc) ||
      (bankForm.reAcc && bankForm.accNo !== bankForm.reAcc) ||
      bankForm.reAcc.length < 8 ||
      bankForm.reAcc.length > 18 ||
      !alphaNumExp.test(bankForm.ifsc) ||
      (bankForm.ifsc.length > 0 && bankForm.ifsc.length !== 11) ||
      !bankForm.accNo ||
      !bankForm.ifsc ||
      !bankForm.accType ||
      !bankForm.branch ||
      !bankForm.reAcc ||
      !bankForm.bankName
    );
  };
  const isValidEditForm = () => {
    return !(
      bankForm.accNo.length < 8 ||
      bankForm.accNo.length > 18 ||
      !alphaNumExp.test(bankForm.ifsc) ||
      (bankForm.ifsc.length > 0 && bankForm.ifsc.length !== 11) ||
      !bankForm.accNo ||
      !bankForm.ifsc ||
      !bankForm.branch ||
      !bankForm.bankName
    );
  };


  const getEditBankDet = async () => {
    const editDatRes = await GetAllNewExistingSRDetails(srId);
    if (editDatRes.result.new_data.bankAccountChangeDetails.length > 0) {
      editDatRes.result.new_data.bankAccountChangeDetails.map((ele: any) => {
        if (ele.new_bank_details === "No") {
          ele.BankAccountNumber = ele.account_number;
          ele.ReEnterBankAccountNumber = ele.re_enter_account_number;
          ele.IFSC_Code = ele.ifsc_Code;
          ele.BankName = ele.bank_name;
          ele.BankCity = ele.bank_city;
          ele.BankBranch = ele.bank_branch;
          ele.BankAccType = ele.current_account_savings_account;
          ele.MICR_Code = ele.micr_code;
          ele.DefaultBank =
            ele.default_account_flag && ele.bank_modified ? "Yes" : "No";
          ele.ReceivedProof = ele.received_proof;
      
        }
      });
    }
    if (editDatRes.result.documents)
      setFileDet({
        fileName: editDatRes.result.documents[0].fileName,
        base64Data: editDatRes.result.documents[0].fileData,
        fileType: editDatRes.result.documents[0].documentTypeName.includes(
          "Cancelled"
        )
          ? "Cancelled Cheque"
          : "Bank Statement",
      });
    let newBankRes = editDatRes.result.new_data.bankAccountChangeDetails.filter(
      (ele: any) => {
        if (ele.new_bank_details === "Yes") return ele;
      }
    )[0];
    if (newBankRes) {
      setAddBank(true);
      setBankForm({
        ...bankForm,
        accName: editDatRes.result.old_data.fullAcName,
        accCode: editDatRes.result.old_data.accountcode,
        accNo: newBankRes.account_number,
        ifsc: newBankRes.ifsc_Code,
        micr: newBankRes.micr_code,
        ifsc_Code: newBankRes.ifsc_Code,
        micr_code: newBankRes.micr_code,
        account_number: newBankRes.account_number,
        accType: newBankRes.current_account_savings_account,
        city: newBankRes.bank_city,
        branch: newBankRes.bank_branch,
        reAcc: newBankRes.re_enter_account_number,
        bankName: newBankRes.bank_name,
        primaryAcc: newBankRes.default_account_flag,
      });
      // setmicrArr([
      //   { value: newBankRes.micr_code, display: newBankRes.micr_code },
      // ]);
    } else
      setBankForm({
        ...bankForm,
        accName: editDatRes.result.old_data.fullAcName,
        accCode: editDatRes.result.old_data.accountcode,
      });
    patchExistingBankForm(
      editDatRes.result.new_data.bankAccountChangeDetails.filter((ele: any) => {
        return ele.new_bank_details === "No";
      }),
      newBankRes
    );
  };
  const getBankIdentifyChanges = () => {
    let result = "";
    if(editExisting) result = "Changes In Existing Bank";
    if (existingBankDetModified() && !addBank) result = "Interchange";
    if (bankForm.primaryAcc) result = "Addition with default";
    if (!bankForm.primaryAcc && addBank) result = "Addition without default";
    if (existingBankDetModified() && addBank && !bankForm.primaryAcc)
      result = "Addition without default & Interchange";
    return result;
  };
  const checkExistingBankSR = async () => {
    props.showFooter(false);
    setExistingBankSR("");
    getExistingBankDetails();
  };
  const patchExistingBankForm = async (bank: any, newBankRes?: any) => {
    let bankDet = bank.BankDetails || bank;

    bankDet.forEach((ele: any) => {
      ele.oldDefBankVal = ele.DefaultBank;
    });
    setExistingBankDet(bankDet);
    if (!srId)
      setBankForm({
        ...bankForm,
        accName: bank.FullAcName,
        accCode: bank.AccountCode,
      });
    props.setLoader(false);
    if (bankDet.length > 5)
      setErrorMsg(
        "You can only add max upto 6 bank accounts. If you wish to make changes to this please get in touch with RM."
      );
  };
  const getExistingBankDetails = async () => {
    try {
      let res = await GetEquityReactivationClientValidation();

      if (
        res &&
        res.result &&
        res.result.length > 0 &&
        res.result[0].BankDetails &&
        res.result[0].BankDetails.length > 0
      ) {
        let isFundingBank = res.result[0].BankDetails.some((ele: any) => {
          return ele.FundingBank === "Yes";
        });
        if (isFundingBank)
          openSRErrorPopup(
            "Bank modification for funding account is not allowed online. Kindly contact your RM."
          );
        patchExistingBankForm(res.result[0]);
      } else {
        openSRErrorPopup();
      }
    } catch (err) {
      openSRErrorPopup();
    }
  };

  const updateDetails = (val: any) => {
    setBankForm({
      ...bankForm,
      ifsc: val.ifsc,
      micr: val.micr,
      branch: val.branch,
      city: val.city,
      bankName: val.bankName,
    });
   // setmicrArr([{ value: val.micr, display: val.micr }]);
    setErrors({
      ...errors,
      ifscError: val.ifsc.length !== 11 ? "Invalid ifsc code" : "",
    });
    setIfscPop(false);
  };
  const onSet = (name: string, val: any) => {
    setBankForm({ ...bankForm, [`${name}`]: val });
  };

  const inputChangeIfsc = async (name: string, val: any) => {
    //setMicrList([]);
    //setmicrArr([]);
    props.setLoader(true);
    let ifscDetails = await getBankListForIfsc({ ifsccode: val.toUpperCase() });
    try {
      if (
        ifscDetails &&
        ifscDetails.data.ecoIBeatsBank.length > 0 &&
        val.length === 11
      ) {
        let setIfsc = ifscDetails.data.ecoIBeatsBank[0];
        // let micrArr = ifscDetails.data.ecoIBeatsBank.map((list: any) => {
        //   return { value: list.micr, display: list.micr };
        // });
       // setMicrList(ifscDetails.data.ecoIBeatsBank);
        //setmicrArr(micrArr);

        setBankForm({
          ...bankForm,
          ifsc: setIfsc.ifsccode,
          micr: setIfsc.micr,
          city: setIfsc.bankcity,
          branch: setIfsc.branch,
          bankName: setIfsc.bankname,
        });

        setErrors({ ...errors, ifscError: "" });
        if (
          !(
            setIfsc.micr &&
            setIfsc.ifsccode &&
            !errors.accNoError &&
            !errors.reAccError &&
            bankForm.accNo &&
            bankForm.reAcc
          )
        )
          props.setLoader(false);
      } else {
        props.setLoader(false);
        setErrors({ ...errors, ifscError: "Invalid ifsc code" });
      }
    } catch (error) {
      openSRErrorPopup();
    }
  };
  const defaultBankValidation = async (accNo: string, ifsc: string) => {
    props.setLoader(true);
    let queryParams = `${accNo}/${ifsc}`;
    let response = await getDefaultBankValidationDetails(queryParams);
    try {
      if (response.statuscode === 200) {
        setDefaultBankMsg(
          response.result[0].ValidationStatus ===
            "Failed, This bank account is already mapped as default in another Trading account. Kindly add unique account or select another unique account as default."
            ? "This bank account is already mapped as default in another Trading account. Please change new bank details or retain original default account."
            : response.result[0].ValidationStatus
        );
        props.setLoader(false);
        return response.result[0].ValidationStatus;
      } else {
        setDefaultBankMsg(response.statusmessage);
        props.setLoader(false);
        return response.statusmessage;
      }
    } catch (err) {
      openSRErrorPopup();
    }
  };
  const isPennyDropSuccess = async () => {
    try {
      let pennyDrop;
      if(primaryBankModified && !srId){
        pennyDrop = await checkPennyDrop({
          applicationid: bankForm.accCode,
          account_number: tempBank.accNo,
          ifsc: tempBank.ifsc,
          name: bankForm.accName,
          source_system: 2,
        });
      }else{
        pennyDrop = await checkPennyDrop({
          applicationid: bankForm.accCode,
          account_number: bankForm.accNo,
          ifsc: bankForm.ifsc,
          name: bankForm.accName,
          source_system: 2,
        });
      }     
      if (pennyDrop && pennyDrop.data) {
        //Correct data for JSON parse
        const data = pennyDrop.data.value
          .toString()
          .replace('}"', "}")
          .replace('"{', "{");
        let checkObj = JSON.parse(data);
        if (checkObj &&( Number(checkObj.code) === 200 || Number(checkObj.code) === 201 )) {
          if (Number(checkObj.score) && Number(checkObj.score) >= 85) {
            setPennyResponse("success");
            return "success";
          } else if (checkObj.account_status === "FAILED") {
            setPennyResponse("The Bank Validation was unsuccessful.Please proceed with your documents upload and e-sign to modify/update bank details.");
            return "The Bank Validation was unsuccessful.Please proceed with your documents upload and e-sign to modify/update bank details.";
          } else if (checkObj.account_status === "COMPLETED"){
            setPennyResponse("The Bank Validation was unsuccessful.Please proceed with your documents upload and e-sign to modify/update bank details.");
            return "The Bank Validation was unsuccessful.Please proceed with your documents upload and e-sign to modify/update bank details.";
          }
        } else {
            setPennyResponse("The Bank Validation was unsuccessful.Please proceed with your documents upload and e-sign to modify/update bank details.");
            return "The Bank Validation was unsuccessful.Please proceed with your documents upload and e-sign to modify/update bank details.";
        }
      }
      setPennyResponse("failed");
      return "failed";
    } catch (error) {
      setPennyResponse("failed");
      return "failed";
    }
  };

  const openSRSuccessPopup = (createSRRes: any) => {
    props.setLoader(false);
    let paramObj: any = {
      type: "bankModification",
      headerText: "We have received your request!",
      popupType: "Success",
      content: (documentUpload ? "":"Your bank details are validated successfully.") + invOnlyAcc ? "We have received your request. Status of your request will be communicated through email":"Your request will be updated within TWO working days. Status of your request will be communicated through Email",
    };

    if (createSRRes.base64Data) {
      paramObj.btnText = "Download E-Signed Form";
      paramObj.base64Data = createSRRes.base64Data;
    } else if(createSRRes.Data && createSRRes.Data.refId){
      paramObj.btnText = "Download E-Signed Form";
      paramObj.refId = createSRRes.Data.refId;
    } else if(createSRRes.prefilled){
      paramObj.btnText = "Download form for your reference";
      paramObj.base64Data = createSRRes.prefilled;
    }
    props.onSubmit("bankModification", paramObj);
  };
  const submitSR = async (PennyResponse?: any) => {
    props.setLoader(true);
    let autoQc = documentUpload ? "No" : PennyResponse === "success" ? "Yes" : "NA";
    setAutoQC(autoQc);
    let fileDetail = [];
    if (fileDet.fileName)
      fileDetail.push({
        fileName: fileDet.fileName,
        fileData: fileDet.base64Data,
        documentTypeName:
          fileDet.fileType === "Cancelled Cheque"
            ? "CancelledCheque"
            : "BankStatement",
      });
    if (fileDet.fileType === "Cancelled Cheque") {
      let requestObj = {
        applicationid: bankForm.accCode,
        base64document: fileDet.base64Data,
        documentcategory: "Cheque",
        documentid: 117,
        source: "DIY",
      };
      try {
        autoQc = await getAutoQc(requestObj, {
          accNo: bankForm.accNo,
          ifsc: bankForm.ifsc,
          bankName: bankForm.bankName,
          // micr: bankForm.micr,
        });
      } catch (error) {
        openSRErrorPopup();
      }
    }

    let banks = [];
    existingBankDet.forEach((ele: any, i: number) => {
      if (!editExisting || (editExisting && editBankNo!=i)){
      banks.push({
        bank_name: ele.BankName,
        account_number: ele.BankAccountNumber,
        ifsc_Code: ele.IFSC_Code,
        micr_code: ele.MICR_Code,
        bank_city: ele.BankCity,
        bank_branch: ele.BankBranch,
        current_account_savings_account: ele.BankAccType.includes("Savings")
          ? "Savings"
          : "Current",
        re_enter_account_number: ele.BankAccountNumber,
        default_account_flag: srId
          ? (ele.DefaultBank === "Yes" && !bankForm.primaryAcc) ||
            (existingBankDet.length === 1 && !bankForm.primaryAcc) ||
            (isPrimBnkNotModif() &&
            ele.default_account_flag &&
            addBank &&
            !bankForm.primaryAcc
              ? true
              : false)
          : ele.oldDefBankVal === "Yes" && !primaryBankModified
          ? true
          : ele.oldDefBankVal !== ele.DefaultBank,
        bank_modified: srId
          ? (ele.oldDefBankVal === ele.DefaultBank &&
              ele.DefaultBank === "No" &&
              ele.bank_modified) ||
            (ele.oldDefBankVal !== ele.DefaultBank &&
              ele.DefaultBank === "Yes" &&
              !ele.bank_modified) ||
            (existingBankDet.length === 1 ? bankForm.primaryAcc : false) ||
            (ele.oldDefBankVal !== ele.DefaultBank &&
              ele.DefaultBank === "Yes" &&
              ele.bank_modified &&
              bankForm.primaryAcc) ||
            (ele.oldDefBankVal === ele.DefaultBank &&
              ele.DefaultBank === "Yes") ||
            (addBank &&
              bankForm.primaryAcc &&
              ele.default_account_flag &&
              ele.DefaultBank === "No")
          : ele.oldDefBankVal === "Yes" && primaryBankModified
          ? true
          : ele.oldDefBankVal !== ele.DefaultBank,
        RecievedProof: ele.RecievedProof || ele.ReceivedProof,
        NewBankDetails: "No",
        penny_drop: (ele.DefaultBank === "Yes" && ele.oldDefBankVal === "No")
          ? props.childSr
            ? PennyResponse === "success"
              ? "Yes"
              : "No"
            : documentUpload
            ? "No"
            : "Yes"
          : "No"
      });
      } else if( editExisting && editBankNo==i){
        banks.push({
          bank_name: bankForm.bankName,
          account_number: bankForm.accNo,
          ifsc_Code: bankForm.ifsc,
          // micr_code: bankForm.micr,
          bank_city: bankForm.city,
          bank_branch: bankForm.branch,
          current_account_savings_account: bankForm.accType,
          re_enter_account_number: bankForm.accNo,
          default_account_flag: isPrimBnkNotModif() ? bankForm.primaryAcc : (ele.DefaultBank == "Yes"),
          bank_modified: true,
          RecievedProof: false,
          NewBankDetails: "Existing",
          penny_drop: props.childSr
            ? PennyResponse === "success"
              ? "Yes"
              : "No"
            : documentUpload
            ? "No"
            : "Yes",
        });
      }
    });

    if (addBank)
      banks.push({
        bank_name: bankForm.bankName,
        account_number: bankForm.accNo,
        ifsc_Code: bankForm.ifsc,
        // micr_code: bankForm.micr,
        bank_city: bankForm.city,
        bank_branch: bankForm.branch,
        current_account_savings_account: bankForm.accType,
        re_enter_account_number: bankForm.reAcc,
        default_account_flag: bankForm.primaryAcc,
        bank_modified: true,
        RecievedProof: false,
        NewBankDetails: "Yes",
        penny_drop: props.childSr
          ? PennyResponse === "success"
            ? "Yes"
            : "No"
          : documentUpload
          ? "No"
          : "Yes",
      });
    let reqObj: any = {
      requestType: "Bank Modification",
      dpID: await getDepositoryDet(),
      banks: banks,
      AutoQC: PennyResponse === "success" ? "Yes" : "No",
      fileAttaches: fileDetail,
      bank_IdentifyChanges: getBankIdentifyChanges(),
    };
    if (srId) {
      let autoQC =
        !documentUpload && addBank && !props.childSr ? "Yes" : autoQc;
      reqObj.serviceRequestId = srId;
      reqObj.ParentId = props.childSr
        ? PennyResponse === "success"
          ? false
          : true
        : false;
      reqObj.SRType = "BankChangeMode";
      reqObj.attachment = autoQC === "Yes" ? [] : reqObj.fileAttaches;

      delete reqObj.requestType;
      delete reqObj.fileAttaches;
      if (!props.childSr) delete reqObj.dpID;
      // console.log("reqObj", reqObj);

      let resp = await createSRDocumentUpload([reqObj]);
      // let resp = "All SR Details Updated successfully.";
      if (
        resp &&
        (resp === "All SR Details Updated successfully." ||
          resp === "Child SR Details Updated successfully.")
      ) {
        if (props.childSr) {
          props.next();
          return;
        }
        setSerReqId(srId);
        setBankForm({ ...bankForm, submitted: true });

        if (autoQC === "Yes") proceedToEsign(srId);
        else if (fileDet.fileName) {
          props.setLoader(false);
          setCheckAutoQcFlag(
            setInterval(async () => {
              let serviceReqList = await asyncGetServiceRequest();
              if (serviceReqList.length > 0) {
                serviceReqList.map((ele: any) => {
                  if (
                    ele.RequestId.toString() === srId.toString() &&
                    ele.RequestStatus === "PendingForEsign"
                  )
                    setAutoQC("Yes");
                });
              }
            }, 10000)
          );
        }
      } else {
        openSRErrorPopup();
      }
    } else {
      try {
        let createSRRes: any;
        if (!props.childSr) {
          createSRRes = await CreateServiceRequestDetails(reqObj);
          if (
            typeof createSRRes === "string" &&
            createSRRes.includes(
              "Previous Request already open for this account-"
            )
          ) {
            openExistSrPopup();
            return;
          } else if (
            createSRRes === "Bank Modification SR is Created successfully."
          ) {
            openSRSuccessPopup(createSRRes);
            return;
          }
        } else {
          reqObj.requestType = "BANKDETAILS";
          reqObj.parent_id = props.srId;
          delete reqObj.fileAttaches;
          reqObj.AutoQC = addBank
            ? PennyResponse === "success"
              ? "Yes"
              : "No"
            : "No";

          const createChildSr = await CreateChildServiceRequestDetails(reqObj);

          if (
            typeof createChildSr === "string" &&
            createChildSr.includes(
              "Previous Request already open for this account-"
            )
          ) {
            openExistSrPopup();
            return;
          } else {
            if (
              createChildSr.Message ===
              "Bank Modification SR is Created successfully."
            ) {
              props.next();
              return;
            }
          }
        }
        if (createSRRes && createSRRes.Message) {
          setSerReqId(createSRRes.Id);
          setBankForm({ ...bankForm, submitted: true });
          if(PennyResponse === "success"){
            let prefillFormpdfRes = await esignService.getPreFilledFormPDF(createSRRes.Id, "bank");
            if (prefillFormpdfRes) {
              createSRRes.prefilled = prefillFormpdfRes;
              // esignService.base64toPDF(prefillFormpdfRes);
              openSRSuccessPopup(createSRRes);
            }
          } else if(createSRRes.Message == "We have received your request for updating your bank accounts. This request will be processed in 2-3 business days"){
            let esignSuccess = await proceedToEsign(createSRRes.Id);
            // if(esignSuccess){
            //   openSRSuccessPopup(esignSuccess);
            // }
          }else if (!documentUpload || autoQc === "NA"){
            await proceedToEsign(createSRRes.Id);
          }else {
            props.setLoader(false);
            setCheckAutoQcFlag(
              setInterval(async () => {
                let serviceReqList = await asyncGetServiceRequest();
                if (serviceReqList.length > 0) {
                  serviceReqList.map((ele: any) => {
                    if (
                      ele.RequestId.toString() === createSRRes.Id.toString() &&
                      ele.RequestStatus === "PendingForEsign"
                    )
                      setAutoQC("Yes");
                  });
                }
              }, 10000)
            );
          }
        } else openSRErrorPopup();
      } catch (err) {
        openSRErrorPopup();
      }
    }
  };
  const getDepositoryDet = async () => {
    try {
      const resp = await GetDepositoryDetails();

      if (resp && resp.dPIdField && resp.dPAccountNumberField) {
        return resp.dPIdField + resp.dPAccountNumberField;
      } else {
        return "None";
      }
    } catch (error) {
      openSRErrorPopup();
    }
  };
  const submitDetails = async () => {
    if (props.childSr) {
      props.setLoader(true);
      if (addBank || primaryBankModified) {
        if (addBank) {
          const penny = await isPennyDropSuccess();
          // if (penny === "INVALID ACCOUNT NUMBER OR IFSC PROVIDED") {
          //   props.setLoader(false);
          // } else {
            submitSR(penny);
          // }
        } else submitSR();
      } else {
        props.next();
        return;
      }
    } else {
      if (documentUpload) {
        props.setLoader(true);
        if (autoQC === "Yes") proceedToEsign();
        else submitSR();
      } else {
        if (addBank || editExisting || (primaryBankModified && !srId)) {
          let newBankEdited = false;
          newBankEdited =
            bankForm.account_number !== bankForm.accNo ||
            bankForm.ifsc_Code !== bankForm.ifsc 
            // || bankForm.micr_code !== bankForm.micr;
          if (!newBankEdited) {
            if (srId && !fileDet.fileName) submitSR();
            else setDocumentUpload(true);
            return;
          }

          props.setLoader(true);
          let pennyResponse = await isPennyDropSuccess();
          if (pennyResponse === "success"){
            submitSR(pennyResponse);
          // } else if (
          //   pennyResponse === "INVALID ACCOUNT NUMBER OR IFSC PROVIDED"
          // ) {
          //   props.setLoader(false);
          //   if (!props.childSr) setDocumentUpload(false);
          //   else submitSR();
          } else {
            props.setLoader(false);
            if (!props.childSr) {
              setDocumentUpload(true);
              props.srDropDown(true);
            } else submitSR();
          }
        } else {
          // if (srId) setFileDet({});
          setDocumentUpload(true);
          // setLoader(false);
          // if (!props.childSr) {
          //   setDocumentUpload(true);
          //   props.srDropDown(true);
          // } else {
          // setLoader(true);
          // submitSR();
          // }
        }
      }
    }
  };
  const proceedToEsign = async (val?: any) => {
    try {
      let result: any = await esignService.proceedToEsign(
        val ? val : serReqId,
        "bank",
        true
      );
      if (!result) openErrorPopup();
      else return true;
    } catch (err) {
      openErrorPopup();
    }
  };

  const openErrorPopup = () => {
    props.setLoader(false);
    props.onSubmit("bankModification", {
      headerText: "There was some error while proceeding with esign process.",
    });
  };

  const openSRErrorPopup = (mess?: string) => {
    props.setLoader(false);
    props.onSubmit("bankModification", {
      headerText: mess
        ? mess
        : "There was some problem in raising service request. Please try again later.",
    });
  };
  const openExistSrPopup = () => {
    props.setLoader(false);
    props.onSubmit("bankModification", {
      headerText: "You have an active service request",
      content:
        "You already have an active service request. Once it is updated, you will be able to raise new request.",
    });
  };
  const onChange = (type: any, val: any) => {
    switch (type) {
      case "accNo":
        if (bankForm.accNo.length >= 8 && bankForm.accNo.length <= 18) {
          setErrors({
            ...errors,
            reAccError:
              val !== bankForm.reAcc && bankForm.reAcc
                ? bankForm.reAcc.length < 8 || bankForm.reAcc.length > 18
                  ? "Account number min 8 and max 18"
                  : "Account number doesn't match"
                : "",
            accNoError: "",
          });
        } else if (bankForm.accNo.length === 0) {
          setErrors({
            ...errors,
            accNoError: "",
          });
          setBankForm({ ...bankForm, [`${type}`]: "" });
        } else
          setErrors({
            ...errors,
            accNoError: "Account number should be 8-18",
          });

        break;
      case "reAcc":
        if (bankForm.reAcc.length >= 8 && bankForm.reAcc.length <= 18) {
          setErrors({
            ...errors,
            reAccError:
              bankForm.accNo && bankForm.accNo !== val
                ? "Account number doesn't match"
                : "",
          });
        } else if (bankForm.reAcc.length === 0) {
          setErrors({
            ...errors,
            reAccError: "",
          });
          setBankForm({ ...bankForm, [`${type}`]: "" });
        } else
          setErrors({
            ...errors,
            reAccError: "Account number should be 8-18",
          });
        break;
    }
  };
  const handleUploadDetails = (val: any) => {
    setFileDet(val);
  };
  const onSetExistingBank = (name: string, value: any, id?: number) => {
    let dataup = [...existingBankDet];
    existingBankDet.forEach((ele: any, i: any) => {
      if (srId) {
        if (Number(id) !== Number(i)) {
          dataup[i] = {
            ...existingBankDet[i],
            [`${name}`]:
              existingBankDet[i].bank_modified &&
              !existingBankDet[i].default_account_flag &&
              value === "No"
                ? "Yes"
                : "No",
          };
          // console.log("dataup[i]", dataup[i]);
        } else {
          dataup[i] = { ...existingBankDet[i], [`${name}`]: value };
        }
      } else if (ele.oldDefBankVal !== "Yes") {
        if (Number(id) !== Number(i)) {
          dataup[i] = { ...existingBankDet[i], [`${name}`]: "No" };
        } else {
          dataup[i] = { ...existingBankDet[i], [`${name}`]: value };
        }
      }
    });
    // console.log("dataup", dataup);

    setExistingBankDet(dataup);
  };
  const noDefaultBank = () => {
    // console.log("existingBankDet", existingBankDet);

    return existingBankDet.every((ele: any) => {
      // console.log("ele", ele);

      if (ele.DefaultBank === "No") return ele;
    });
  };
  
  const isAccClouserOpen = serviceReqListArr?.length && serviceReqListArr.find((item:any) =>
    item.RequestType === 'Online Closure' && (item.RequestStatus === 'EsignSubmitted' || item.RequestStatus === 'Assigned' || item.RequestStatus === 'Open'  || item.RequestStatus === 'PendingForEsign')
  );
  return (
    <>
      { !isAccClouserOpen? 
        <>
          {existingBankSR && (
            <StatusScreen
              headerText="Bank Modification in Process"
              desc="Another Bank modification request is under process. Please raise any new requests only once those are processed."
              status="Pending"
            />
          )}
          {!existingBankSR && (
            <div
              className="finalScreen bankAccount"
              style={{ pointerEvents: props.loader ? "none" : "all" }}
            >
              {!documentUpload && (
                <>
                  {existingBankDet.length < 6 && (addBank || editExisting)&& (
                    <p className="blue-text-msg pd-b20">
                      Re. 1 will be credited to your account for verification of
                      your account
                    </p>
                  )}

                  {existingBankDet.map((bankdetails: any, key: number) => {
                    return (
                      <>                
                        <div className="custom--row"></div>
                        <p className="text-indicator"></p>
                        <div>
                          {!editExisting && (<div className="display-block text-right">
                            <i className="edel-icon-edit"></i>
                            <a className="bold-text link-text"
                              onClick={(e: any) => {
                                e.preventDefault();
                                setEditExisting(!editExisting);
                                setEditBankNo(key);
                                setAddBank(false);
                                setErrors("");
                                setErrorMsg("");
                                setDefaultBankMsg("");
                                setPennyResponse("");
                                setBankForm({
                                  ...bankForm,
                                  ifsc: bankdetails.IFSC_Code,
                                  micr: bankdetails.MICR_Code,
                                  branch: bankdetails.BankBranch,
                                  accNo: bankdetails.BankAccountNumber,
                                  bankName: bankdetails.BankName,
                                  city: bankdetails.BankCity
                                });
                              }}
                              > Edit </a>
                          </div>)}
                          {editExisting && editBankNo==key && (<div className="display-block text-right">
                            <a className="bold-text link-text"
                              onClick={(e: any) => {
                                e.preventDefault();
                                setEditExisting(!editExisting);
                                setEditBankNo(-1);
                              }}
                              > Cancel </a>
                          </div>)}
                          <div
                            className={
                              key === 0 &&
                              !(existingBankDet.length < 6 && addBank)
                                ? "align-center acctDetails primary-flex mg-t-15"
                                : "display-flex align-center acctDetails primary-flex  mg-t0"
                            }
                          >
                            <h5 className="field-subHead bold-text">
                              Bank Account {key + 1}
                            </h5>
                            {((!srId && bankdetails.oldDefBankVal !== "Yes") ||
                              (srId &&
                                ((bankdetails.bank_modified &&
                                  bankdetails.default_account_flag) ||
                                  (!bankdetails.bank_modified &&
                                    !bankdetails.default_account_flag)))) && (
                              <div className="display-flex align-center acctDetails__checkbox  ">
                                {((editExisting && editBankNo==key) || !editExisting) && (
                                <Checkbox
                                  checked={
                                    bankdetails.DefaultBank === "Yes"
                                      ? true
                                      : false
                                  }
                                  name="consent"
                                  onChange={async () => {
                                    if(editExisting && editBankNo==key || !editExisting){
                                      if (bankdetails.DefaultBank === "No") {
                                        setBankForm({
                                          ...bankForm,
                                          primaryAcc: false,
                                        });
                                        onSetExistingBank(
                                          "DefaultBank",
                                          bankdetails.DefaultBank === "Yes"
                                            ? "No"
                                            : "Yes",
                                          key
                                        );
                                        setTempBank({accNo: bankdetails.BankAccountNumber, ifsc: bankdetails.IFSC_Code})
                                      } else {
                                        onSetExistingBank(
                                          "DefaultBank",
                                          bankdetails.DefaultBank === "Yes"
                                            ? "No"
                                            : "Yes",
                                          key
                                        );
                                      }
                                    }                        
                                  }}
                                  disabled={checkIfHasMatchAndDef()}
                                >
                                  <span>Make this your Primary Account</span>
                                </Checkbox>)}
                              </div>
                            )}
                            {(srId
                              ? ((bankdetails.bank_modified &&
                                  !bankdetails.default_account_flag &&
                                  !bankForm.primaryAcc &&
                                  !existingBankDetModified()) ||
                                  (!bankdetails.bank_modified &&
                                    bankdetails.default_account_flag &&
                                    !bankForm.primaryAcc &&
                                    !existingBankDetModified())) &&
                                (addBank
                                  ? (noDefaultBank() && !bankForm.primaryAcc) ||
                                    (!noDefaultBank() &&
                                      !bankForm.primaryAcc &&
                                      bankdetails.DefaultBank === "Yes")
                                  : bankdetails.DefaultBank === "Yes" ||
                                    (noDefaultBank() &&
                                      existingBankDet.length === 1 &&
                                      !bankForm.primaryAcc))
                              : bankdetails.oldDefBankVal === "Yes" &&
                                !primaryBankModified) && (
                              <div className="display-flex align-center acctDetails__checkbox">
                                <i className="edel-icon-star-filled"></i>
                                <p>Primary Account</p>
                              </div>
                            )}
                          </div>
                          <div className="custom--row">
                            <div className=" form-field custom-col disabled-field ">
                              {" "}
                              <label className="input-label">Bank Name</label>
                              <div>
                                <InputField
                                  type="text"
                                  defaultValue={
                                    bankdetails.BankName
                                      ? bankdetails.BankName
                                      : ""
                                  }
                                  onChange={() => {}}
                                  onBlur={() => {}}
                                  disabled={true}
                                />
                              </div>
                            </div>
                            <div className=" form-field custom-col disabled-field ">
                              {" "}
                              <label className="input-label">
                                Account Number
                              </label>
                              <div className="italic-placeholder">
                                <InputField
                                  type="number"
                                  defaultValue={
                                    bankdetails.BankAccountNumber
                                      ? bankdetails.BankAccountNumber
                                      : ""
                                  }
                                  onChange={() => {}}
                                  onBlur={() => {}}
                                  disabled={true}
                                />
                                <p className="msgField">
                                  {bankdetails.BankAccType.includes(
                                    "Savings"
                                  ) && "Savings Account"}

                                  {bankdetails.BankAccType.includes(
                                    "Current"
                                  ) && "Current Account"}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="custom--row">
                            <div className={editExisting && editBankNo==key ? " form-field custom-col " : " form-field custom-col disabled-field "}>
                              {" "}
                              <div className="display-flex content-space-between align-center">
                                <label className="input-label">IFSC Code</label>
                                {editExisting && editBankNo==key && <div>
                                  <a
                                    href=""
                                    className="field-subHead bold-text blue-text mob-absolute"
                                    onClick={(e: any) => {
                                      e.preventDefault();
                                      setIfscPop(true);
                                    }}
                                  >
                                    Search IFSC
                                  </a>
                                </div>}
                              </div>
                              <div className="mob-relative">
                                <InputField
                                  type="text"
                                  defaultValue={ editExisting && editBankNo==key ? bankForm.ifsc :(bankdetails.IFSC_Code ? bankdetails.IFSC_Code : "") }
                                  onMouseOut={(val: any) => {
                                    if (!alphaNumExp.test(val)) {
                                      setErrors({
                                        ...errors,
                                        ifscError: "Ifsc code must be Alphanumeric",
                                      });
                                    } else if (
                                      val.length > 0 &&
                                      val.length !== 11
                                    ) {
                                      setErrors({
                                        ...errors,
                                        ifscError: "Invalid ifsc code",
                                      });
                                    }
                                  }}
                                  maxLength={11}
                                  onChange={(val: any) => {
                                    setErrors({
                                      ...errors,
                                      ifscError: "",
                                    });
                                    if (alphaNumExp.test(val)) {
                                      if (val.length === 11) {
                                        inputChangeIfsc("ifsc", val);
                                      } else {
                                        setBankForm({
                                          ...bankForm,
                                          ifsc: val,
                                          micr: "",
                                          branch: "",
                                        });
                                       // setmicrArr([]);
                                      }
                                    }
                                  }}                                 
                                  pattern={alphaNumExp}
                                  errorText={editExisting && editBankNo==key ? errors.ifscError : ""}
                                  onBlur={() => {}}
                                  placeholder=""
                                  disabled={!editExisting || editBankNo!=key}
                                />
                                <p className="msgField">
                                  {editExisting && editBankNo==key ? bankForm.branch : bankdetails.BankBranch}
                                </p>
                              </div>
                            </div>
                            {/* <div className={editExisting && editBankNo==key ? " form-field custom-col " : " form-field custom-col disabled-field "}>
                              {" "}
                              <label className="input-label">MICR Code</label>
                              <div className="italic-placeholder">
                                <InputField
                                  type="number"
                                  defaultValue={ editExisting && editBankNo==key ? bankForm.micr :(bankdetails.MICR_Code ? bankdetails.MICR_Code : "") }
                                  onChange={() => {}}
                                  onBlur={() => {}}
                                  placeholder=""
                                  disabled={!editExisting || editBankNo!=key}
                                />
                              </div>
                            </div> */}
                          </div>
                        </div>
                      </>
                    );
                    // }
                  })}
                </>
              )}
              {!documentUpload && (
                <>
                  {addBank && (
                    <div className="addBankAccount">
                      <div className="display-flex align-center acctDetails content-space-between ">
                        <div className="display-flex align-center  ">
                          <h5 className="field-subHead bold-text">
                            Bank Account {existingBankDet.length + 1}
                          </h5>
                        </div>
                        {/* {!srId && ( */}
                        <div>
                          <p
                            className="removeBlock"
                            onClick={() => {
                              setAddBank(false);
                              setBankForm({
                                ...bankForm,
                                accNo: "",
                                ifsc: "",
                                micr: "",
                                accType: bankForm.accType,
                                city: "",
                                branch: "",
                                reAcc: "",
                                bankName: "",
                                primaryAcc: false,
                              });

                              existingBankDet.forEach((ele: any) => {
                                if (noDefaultBank()) {
                                  if (
                                    (ele.bank_modified &&
                                      !ele.default_account_flag) ||
                                    (ele.bank_modified &&
                                      ele.default_account_flag)
                                  )
                                    ele.DefaultBank = "Yes";
                                  else ele.DefaultBank = "No";
                                }
                              });
                              setErrorMsg("");
                              setDefaultBankMsg("");
                              setPennyResponse("");
                              setErrors({
                                errors,
                                accNoError: "",
                                reAccError: "",
                                ifscError: "",
                                duplicBankErr: "",
                              });
                             // setmicrArr([]);
                            }}
                          >
                            <i className="edel-icon-close"></i> Remove
                          </p>
                        </div>
                        {/* )} */}
                      </div>

                      <div>
                        <div className="display-flex radioWrap">
                          <div>
                            <p>Select Account Type</p>
                          </div>
                          <div>
                            <div className="flex-wrap text-left radio-btn">
                              <div>
                                <RadioButton
                                  list={accType[0]}
                                  name={"accType"}
                                  selected={bankForm["accType"]}
                                  onChange={(e) => {
                                    onSet(e.target.name, e.target.value);
                                  }}
                                />
                              </div>
                              <div>
                                <RadioButton
                                  list={accType[1]}
                                  name={"accType"}
                                  selected={bankForm["accType"]}
                                  onChange={(e) => {
                                    onSet(e.target.name, e.target.value);
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div>
                          <p className="text-indicator small--text-indicator">
                            In case of sole proprietorship accounts, please note
                            that if the name on your cheque and name in PAN site
                            does not match, it may result in additional checks
                            to be conducted before reactivation.
                          </p>
                        </div>
                      </div>
                      <div className="custom--row">
                        <div className="form-field custom-col">
                          {" "}
                          <label className="input-label">
                            Enter Account Number
                          </label>
                          <div>
                            <InputField
                              defaultValue={srId ? bankForm.accNo : ""}
                              type="password"
                              maxLength={18}
                              onChange={(val: any) => {
                                setErrors({
                                  ...errors,
                                  accNoError: "",
                                });

                                onSet("accNo", val);
                              }}
                              onMouseOut={(val: any) => {
                                onChange("accNo", val);
                              }}
                              integer={true}
                              onBlur={() => {}}
                              placeholder="Enter Account Number"
                              errorText={errors.accNoError}
                              pattern={integerExp}
                              disablePaste={true}
                            />
                          </div>
                        </div>
                        <div className=" form-field custom-col">
                          {" "}
                          <label className="input-label">
                            Re-enter Account Number
                          </label>
                          <div className="italic-placeholder">
                            <InputField
                              defaultValue={srId ? bankForm.reAcc : ""}
                              min={8}
                              maxLength={18}
                              onChange={(val: any) => {
                                setErrors({
                                  ...errors,
                                  reAccError: "",
                                });
                                onSet("reAcc", val);
                              }}
                              onMouseOut={(val: any) => {
                                onChange("reAcc", val);
                              }}
                              onBlur={() => {}}
                              placeholder="Re-enter Account Number"
                              errorText={errors.reAccError}
                              pattern={integerExp}
                              integer={true}
                              disablePaste={true}
                            />
                            <p className="msgField"></p>
                          </div>
                        </div>
                      </div>
                      <div className="custom--row">
                        <div className="form-field custom-col">
                          {" "}
                          <div className="display-flex content-space-between align-center">
                            <label className="input-label">IFSC Code</label>
                            <div>
                              <a
                                href=""
                                className="field-subHead bold-text blue-text mob-absolute"
                                onClick={(e: any) => {
                                  e.preventDefault();
                                  setIfscPop(true);
                                }}
                              >
                                Search IFSC
                              </a>
                            </div>
                          </div>
                          <div className="mob-relative">
                            <InputField
                              defaultValue={bankForm.ifsc ? bankForm.ifsc : ""}
                              type="text"
                              onBlur={() => {}}
                              onMouseOut={(val: any) => {
                                if (!alphaNumExp.test(val)) {
                                  setErrors({
                                    ...errors,
                                    ifscError: "Ifsc code must be Alphanumeric",
                                  });
                                } else if (
                                  val.length > 0 &&
                                  val.length !== 11
                                ) {
                                  setErrors({
                                    ...errors,
                                    ifscError: "Invalid ifsc code",
                                  });
                                }
                              }}
                              maxLength={11}
                              onChange={(val: any) => {
                                setErrors({
                                  ...errors,
                                  ifscError: "",
                                });
                                if (alphaNumExp.test(val)) {
                                  if (val.length === 11) {
                                    inputChangeIfsc("ifsc", val);
                                  } else {
                                    setBankForm({
                                      ...bankForm,
                                      ifsc: val,
                                      micr: "",
                                      branch: "",
                                    });
                                  //  setmicrArr([]);
                                  }
                                }
                              }}
                              placeholder=""
                              pattern={alphaNumExp}
                              errorText={!editExisting ? errors.ifscError : ""}
                            />
                            <p className="msgField">{bankForm.branch}</p>
                          </div>
                        </div>
                        {/* <div className=" form-field custom-col">
                          {" "}
                          <label className="input-label">MICR Code</label>
                          <div className="italic-placeholder">
                            <TocDropdown
                              selectedValue={bankForm["micr"]}
                              dropdownOptions={micrArr ? micrArr : []}
                              onSelect={(val: any) => {
                                micrList.find((list: any) => {
                                  if (list.micr === val) {
                                    setBankForm({
                                      ...bankForm,
                                      ifsc: list.ifsccode,
                                      micr: list.micr,
                                      city: list.bankcity,
                                      branch: list.branch,
                                      bankName: list.bankname,
                                    });
                                  }
                                });
                              }}
                              isSearchable={false}
                              disabled={micrArr.length === 0}
                            />
                          </div>
                        </div> */}
                      </div>
                    </div>
                  )}
                  {ifscPop && (
                    <BankIfscpop
                      updateBankDetails={updateDetails}
                      searchIfsc={setIfscPop}
                      loader={props.loader}
                      setLoader={props.setLoader}
                    />
                  )}
                  {!addBank && existingBankDet.length < 6 && (
                    <div>
                      {existingBankDet.length < 6 && !editExisting &&(
                        <button
                          type="button"
                          className="ed_button common_button noBg-btn "
                        >
                          <span className="edel-icon-plus"></span>
                          <span
                            onClick={() => {
                              setAddBank(true);
                              if (existingBankDet.length === 5)
                                setErrorMsg(
                                  "You can only add max upto 6 bank accounts. If you wish to make changes to this please get in touch with RM."
                                );
                              else
                                if (invOnlyAcc){
                                  setErrorMsg(
                                  "You can only add one new account at a time. The changes mentioned will be applicable for your Investment account."
                                );
                                }
                                else{
                                  setErrorMsg(
                                  "You can only add one new account at a time. The changes mentioned will be applicable for your Trading and Default Demat account."
                                );
                                }
                                
                            }}
                          >
                            Add Another Bank Account
                          </span>
                        </button>
                      )}
                    </div>
                  )}
                  {bankForm.accNo &&
                    bankForm.reAcc &&
                    bankForm.ifsc.length === 11 &&
                    !errors.accNoError &&
                    !errors.reAccError && (
                      <div className="display-flex align-center bankcheckbox-bottom">
                        <Checkbox
                          checked={bankForm.primaryAcc}
                          name="consent"
                          onChange={async () => {
                            setBankForm({
                              ...bankForm,
                              primaryAcc: !bankForm.primaryAcc,
                            });

                            onSetExistingBank("DefaultBank", "No");
                          }}
                          disabled={checkIfHasMatchAndDef()}
                        >
                          <span>Make this your Primary Account</span>
                        </Checkbox>
                      </div>
                    )}

                  {errorMsg && (
                    <p
                      className={`error-msg ${
                        errorMsg === "fundingBankError" ? "" : "bankerr-blue"
                      }`}
                    >
                      {errorMsg === "fundingBankError"
                        ? "Bank modification for funding account is not allowed online. Kindly contact your RM."
                        : errorMsg}
                    </p>
                  )}

                  {getBankIdentifyChanges() &&
                    getBankIdentifyChanges() ===
                      "Addition without default & Interchange" && (
                      <>
                        <br />
                        <p className="error-msg">
                          You can either add new bank or change default bank.
                        </p>
                      </>
                    )}
                  {errors.duplicBankErr && (
                    <>
                      <br />
                      <p className="error-msg">{errors.duplicBankErr}</p>
                    </>
                  )}
                  {pennyResponse ===
                    "INVALID ACCOUNT NUMBER OR IFSC PROVIDED" && (
                    <>
                      <br />
                      <p className="error-msg">{pennyResponse}</p>
                    </>
                  )}
                  {defaultbankMsg && defaultbankMsg !== "Success" && (
                    <>
                      <br />
                      <p className="error-msg">{defaultbankMsg}</p>
                    </>
                  )}
                </>
              )}
              {documentUpload && pennyResponse === "The Bank Validation was unsuccessful.Please proceed with your documents upload and e-sign to modify/update bank details." && (
                <>
                  <p className="blue-text-msg">{pennyResponse}</p>
                </>
              )}
              {documentUpload && (       
                <BankUpload
                  newBankDet={bankForm}
                  onSubmit={handleUploadDetails}
                  autoQC={autoQC}
                  loader={props.loader}
                  fileDet={fileDet}
                  userConsent={userConsent}
                  setConsent={setUserConsent}
                />
              )}
              {
                <div className="modal-footer common-modal--footer">
                  <div className="mob-center">
                    <button
                      type="submit"
                      className="btn btn-blue login-btn"
                      onClick={(e: any) => {
                        submitDetails();
                        e.preventDefault();
                      }}
                      disabled={
                        editExisting 
                        ? (!documentUpload 
                          ? !isValidEditForm
                          : (!userConsent || !fileDet || (fileDet && !fileDet.fileName))
                        )
                        :
                        (addBank
                          ? !isValidForm() ||
                            (defaultbankMsg && defaultbankMsg !== "Success") ||
                            (documentUpload &&
                              (!userConsent || !fileDet || (fileDet && !fileDet.fileName))) ||
                            (documentUpload &&
                              bankForm.submitted &&
                              autoQC === "No") ||
                            props.loader ||
                            errors.ifscError ||
                            // errors.accNoError ||
                            // errors.reAccError ||
                            errors.duplicBankErr ||
                            pennyResponse ===
                              "INVALID ACCOUNT NUMBER OR IFSC PROVIDED" ||
                            (getBankIdentifyChanges() &&
                              getBankIdentifyChanges() ===
                                "Addition without default & Interchange")
                          : props.childSr
                          ? errorMsg && errorMsg === "fundingBankError"
                          : (autoQC === "No" &&
                              bankForm.submitted &&
                              documentUpload) ||
                            (documentUpload &&
                              (!userConsent || !fileDet || (fileDet && !fileDet.fileName))) ||
                            (!primaryBankModified && !srId) ||
                            (srId && !addBank && isPrimBnkNotModif()) ||
                            (defaultbankMsg && defaultbankMsg !== "Success") ||
                            existingBankDet.length === 1
                        )
                      }
                    >
                      {!bankForm.submitted
                        ? props.childSr
                          ? "Proceed"
                          :( documentUpload ? "Confirm & Esign" : "Submit") 
                        : !documentUpload
                        ? "Submit"
                        : "Confirm & Esign"}
                    </button>

                    <button
                      type="submit"
                      disabled={
                        (consentType &&
                          (consentType?.includes("email") ||
                            consentType?.includes("mobile") ||
                            consentType?.includes("emailMob"))) ||
                        addressConsent?.includes("Change of Address")
                          ? true
                          : false
                      }
                      className="btn btn-olink login-btn"
                    >
                      {!(
                        (consentType &&
                          (consentType?.includes("email") ||
                            consentType?.includes("mobile") ||
                            consentType?.includes("emailMob"))) ||
                        addressConsent?.includes("Change of Address")
                      ) && (
                        <a
                          className="btn btn-olink login-btn"
                          href={
                            window.location.href.includes("ajs")
                              ? config.rootUrl + "clientarea/servicerequest"
                              : config.onePlatformBase + "service-request"
                          }
                        >
                          Cancel
                        </a>
                      )}
                      {((consentType &&
                        (consentType?.includes("email") ||
                          consentType?.includes("mobile") ||
                          consentType?.includes("emailMob"))) ||
                        addressConsent?.includes("Change of Address")) && (
                        <label className="btn btn-olink login-btn">
                          Cancel
                        </label>
                      )}
                    </button>
                  </div>
                </div>
              }
            </div>
          )}
        </>
        : <p className="help-text red line-ht-standard">You have an ongoing account closure request. During this time, you cannot initiate any request.</p>
      }
    </>
  );
});
